import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative mt-1" }
const _hoisted_2 = { class: "w-full cursor-default overflow-hidden rounded-lg bg-white text-left focus:outline-none focus:ring-0 sm:text-sm" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
}, null, -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "relative cursor-default select-none py-2 px-4 text-gray-700"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12l5 5l10 -10" })
], -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComboboxInput = _resolveComponent("ComboboxInput")!
  const _component_ComboboxButton = _resolveComponent("ComboboxButton")!
  const _component_ComboboxOption = _resolveComponent("ComboboxOption")!
  const _component_ComboboxOptions = _resolveComponent("ComboboxOptions")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_Combobox = _resolveComponent("Combobox")!

  return (_openBlock(), _createBlock(_component_Combobox, {
    modelValue: _ctx.storeStatus,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.storeStatus) = $event)),
    nullable: ""
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ComboboxButton, { class: "focus:outline-none focus:ring-0 w-full" }, {
            default: _withCtx(() => [
              _createVNode(_component_ComboboxInput, {
                class: "button-status w-full",
                placeholder: "Status",
                onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.findStatus()), ["enter"])),
                displayValue: (status) => status && status.Value ? status.Value.replaceAll('-', ' ') : '',
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusQuery = $event.target.value))
              }, null, 8, ["displayValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ComboboxButton, {
            class: "absolute inset-y-0 right-0 flex items-center px-2 text-gray-700",
            as: "button"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeOption())),
                class: _normalizeClass([_ctx.storeStatus ? 'block' : 'hidden']),
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, _hoisted_6, 2)),
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: _normalizeClass(["transform transition duration-300", { 'rotate-180': open }]),
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, _hoisted_9, 2))
            ]),
            _: 2
          }, 1024)
        ]),
        _createVNode(_component_TransitionRoot, {
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          onAfterLeave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.statusQuery = ''))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ComboboxOptions, { class: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-2 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-30" }, {
              default: _withCtx(() => [
                (_ctx.filteredItems.length === 0 && _ctx.statusQuery !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Nothing found. "))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredItems, (Item) => {
                      return (_openBlock(), _createBlock(_component_ComboboxOption, {
                        key: Item,
                        selected: Item.Value == _ctx.item,
                        value: Item,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.findStatus()))
                      }, {
                        default: _withCtx(({ selected, active }) => [
                          _createElementVNode("li", {
                            class: _normalizeClass(["relative cursor-default select-none py-2 pl-10 pr-4 capitalize", {
                            'bg-red-50 text-red-600': active || selected,
                            'text-gray-700': !active,
                        }])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["block truncate text-sm", { 'font-medium': selected, 'font-normal': !selected }])
                            }, _toDisplayString(_ctx.helpers.upperFirst(Item.Value).replaceAll('-', ' ')), 3),
                            selected
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["absolute inset-y-0 left-0 flex items-center pl-3", { 'text-red-600': active }])
                                }, _hoisted_12, 2))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["selected", "value"]))
                    }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}